import { IconButton } from "@chakra-ui/react";
import { HiOutlineClipboard } from "react-icons/hi2";
import { toaster } from "@/components/ui/toaster";

export const getCampaignChatUrl = (chatPath) => (chatPath ? `${window.location.origin}/c${chatPath}` : null);

const CampaignChatLinkButton = ({ chatPath, size = "sm" }) => {
    const url = getCampaignChatUrl(chatPath);
    const handleCopy = (e) => {
        e.stopPropagation();
        if (!url) return;
        navigator.clipboard.writeText(url);
        toaster.create({ type: "success", title: "Skopiowano link do czatu kampanii" });
    };

    return (
        <IconButton variant="outlined" size={size} aria-label="Kopiuj link do czatu" title="Kopiuj link do czatu" onClick={handleCopy}>
            <HiOutlineClipboard />
        </IconButton>
    );
};

export default CampaignChatLinkButton;
